import ScrollToTop from './components/ScrollToTop';
import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RequireAuth, RequireAdmin, RequireGuest } from './components/Guards';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Pricing from './pages/Pricing';
import Dashboard from './pages/Dashboard';
import AddAccount from './pages/AddAccount';
import AccountDetails from './pages/AccountDetails';
import Billing from './pages/Billing';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import AdminLogs from './pages/AdminLogs';
import AdminPaidSubscribers from './pages/AdminPaidSubscribers';
import ControlPanel from './pages/ControlPanel';
import HallOfFame from './pages/HallOfFame';
import PublicShare from './pages/PublicShare';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import About from './pages/About';
import Contact from './pages/Contact';

// Discreet global hotkey: Ctrl + Shift + A -> opens admin portal
function AdminHotkey() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.shiftKey && (e.key === 'A' || e.key === 'a')) {
        e.preventDefault();
        navigate('/secure-portal-9x47');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AdminHotkey />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/auth/login" element={<RequireGuest><Login /></RequireGuest>} />
            <Route path="/auth/register" element={<RequireGuest><Register /></RequireGuest>} />
            <Route path="/login" element={<Navigate to="/auth/login" replace />} />
            <Route path="/signin" element={<Navigate to="/auth/login" replace />} />
            <Route path="/signup" element={<Navigate to="/auth/register" replace />} />
            <Route path="/register" element={<Navigate to="/auth/register" replace />} />
            <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/hall-of-fame" element={<RequireAuth><HallOfFame /></RequireAuth>} />
            <Route path="/dashboard/add" element={<RequireAuth><AddAccount /></RequireAuth>} />
            <Route path="/control-panel" element={<RequireAuth><ControlPanel /></RequireAuth>} />
            <Route path="/account/:slug" element={<AccountDetails />} />
            <Route path="/share/:slug" element={<PublicShare />} />
            <Route path="/billing/:planId" element={<RequireAuth><Billing /></RequireAuth>} />
            <Route path="/secure-portal-9x47" element={<AdminLogin />} />
            <Route path="/secure-portal-9x47/console" element={<RequireAdmin><AdminPanel /></RequireAdmin>} />
            <Route path="/secure-portal-9x47/logs" element={<RequireAdmin><AdminLogs /></RequireAdmin>} />
            <Route path="/secure-portal-9x47/paid-subscribers" element={<RequireAdmin><AdminPaidSubscribers /></RequireAdmin>} />
            <Route path="/admin" element={<Navigate to="/" replace />} />
            <Route path="/admin/panel" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
